<template>
  <div class="tweet-detail-page">
    <menubar active="home"></menubar>

    <v-touch class="touch-root"
      @panmove="pageMove"
      @panend="pageMoveEnd"
      :swipe-options="{ direction: 'vertical', threshold: 10 }"
    >
    <div class="back-msg" :style="{opacity: backMsgOpacity}">BACK TO LIST...</div>

      <transition name="pop">
        <tweet-detail
          v-show="isVisible"
          :imgsrc="imgsrc"
          :altsrc="altsrc"
          :tweet="tweet"
          :mindex="mindex"
          :stock="stock"
          @stocked="onstock"
          @unstocked="onunstock"
          :style="{
            [swipeY ? 'transform' : '_dummy']: `translateY(${swipeY}px)`
          }"
        ></tweet-detail>
      </transition>

    </v-touch>
  </div>
</template>

<style scoped>
.touch-root {
  width: 100%;
  height: 100%;
}
.tweet-detail-page {
  height: 100%;
  padding-top: 40px;
}
.back-msg {
  position: absolute;
  top: 50px;
  width: 100%;
  color: #666;
}
/* animation */
.pop-enter-active, .pop-leave-active{
  transition: transform 300ms cubic-bezier(.1,.7,.71,1.17);
}
.pop-enter, .pop-leave{
  transform: scale(0.65);
}
</style>

<script>
import TwApi from '@/api/TwApi'
import UserApi from '@/api/UserApi'
import Menubar from '@/components/Menubar'
import TweetDetail from '@/components/TweetDetail'

const SWIPE_BORDER = 50

export default {
  name: 'TweetDetailPage',
  components: {TweetDetail, Menubar},
  data () {
    return {
      imgsrc: null,
      altsrc: null,
      tweet: null,
      isVisible: false,
      mindex: -1,
      stock: null,
      swipeY: 0
    }
  },
  computed: {
    backMsgOpacity () { return Math.min(1, Math.abs(this.swipeY) / SWIPE_BORDER) }
  },
  methods: {
    onstock (stock) {
      this.stock = stock
      this.$router.push(`/stock/${stock.sid}`)
    },
    onunstock (stock) {
      this.stock = null
      this.$router.push(`/status/${stock.statusid}/${stock.mindex}`)
    },
    pageMove (ev) {
      this.$data.swipeY = ev.deltaY
    },
    pageMoveEnd (ev) {
      this.$data.swipeY = 0
      const shouldMove = Math.abs(ev.deltaY) >= SWIPE_BORDER
      if (shouldMove) {
        const listType = this.$store.state.TweetListPage.listType
        this.$router.push(listType === 'favs' ? '/favs' : '/myimgs')
      }
    }
  },
  mounted () {
    const {id, mindex} = this.$route.params
    if (!id || !mindex) { return }
    UserApi.getToken().then(() => {
      TwApi.status(id).then(tw => {
        const medias = tw['extended_entities'].media
        const media = medias[mindex]
        const src = media['media_url_https']
        this.$data.imgsrc = src
        this.$data.altsrc = `${src}:thumb`
        this.$data.tweet = tw
        this.$data.mindex = mindex * 1 || 0
        this.$data.isVisible = true
      })
    })
  },
  beforeDestroy () {
    this.$data.isVisible = false
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/TweetDetailPage.vue